"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const ProductBox_1 = require("./ProductBox");
const Product_1 = require("../Models/Product");
const Store_1 = require("../Store");
let ProductRecommendations = class ProductRecommendations extends React.Component {
    constructor() {
        super(...arguments);
        this.recommendations = null;
    }
    componentDidMount() {
        this.LoadRecommendations();
    }
    componentDidUpdate(prevProps) {
        if (this.props.productId !== prevProps.productId) {
            this.LoadRecommendations();
        }
    }
    LoadRecommendations() {
        $.ajax({
            type: "GET",
            url: "/api/ProductApi/GetProductRecommendations",
            data: {
                "product": this.props.productId,
                "language": Store_1.default.currentLanguage
            },
            success: function (data) {
                this.recommendations = data.map(json => new Product_1.default(json));
            }.bind(this),
            error: function () {
            }.bind(this)
        });
    }
    render() {
        return (React.createElement("div", { className: "u-my-4 o-product-recommendations" },
            React.createElement("h2", { className: "u-tc s-h2 u-mt-0 u-mb-3" }, Store_1.default.Translations.productRecommendationsText),
            React.createElement("div", { className: "row u-flex-justify--ce" }, this.recommendations && this.recommendations.map(function (product, index) {
                return (React.createElement(ProductBox_1.default, { key: product.id, product: product }));
            }, this))));
    }
};
__decorate([
    mobx_1.observable
], ProductRecommendations.prototype, "recommendations", void 0);
__decorate([
    mobx_1.action.bound
], ProductRecommendations.prototype, "LoadRecommendations", null);
ProductRecommendations = __decorate([
    mobx_react_1.observer
], ProductRecommendations);
exports.default = ProductRecommendations;
